<div class="flex flex-column align-items-center">
  <h1 class="mb-4 text-center">{{ 'SELLER_COLLECT_DATA.HEADER.SUCCESS' | translate }}</h1>
  <p class="mb-3 text-center">{{ 'SELLER_COLLECT_DATA.TEXT.REQUEST_PROCESSED' | translate }}</p>
  <p class="mb-3 text-center">{{ 'SELLER_COLLECT_DATA.TEXT.START_ENJOYING' | translate }}</p>
  <object type="image/svg+xml" data="../../../../../assets/images/success.svg"></object>

  <button pButton pRipple class="simple-button mt-4 md:w-9" (click)="redirectHome()">
    {{ 'SELLER_COLLECT_DATA.LABEL.RETURN_HOME' | translate }}
  </button>
  <br />
  <div>
    {{ 'SELLER_COLLECT_DATA.LABEL.FAQ' | translate }}
    <a
      href="https://help.payme.io/hc/he/articles/4406049668498-%D7%AA%D7%A9%D7%9C%D7%95%D7%9D-%D7%91%D7%99%D7%9F-%D7%A1%D7%A4%D7%A7%D7%99%D7%9D-B2B-"
      target="_blank"
    >
      <u>FAQ</u>
    </a>
  </div>
  <br />
  <div class="text-center">{{ 'SELLER_COLLECT_DATA.LABEL.QUESTION_EMAIL' | translate }}</div>
</div>
